// Copyright (C) Microsoft Corporation. All rights reserved.

export function InitializeExpandableNavigationGallery() {
	const $seeAllLink: JQuery = $('.expandableNavigationGallerySeeAllLink');
	const $items: JQuery = $('.nav-gallery-expandable__cta-grid__column--image');
	let seeAllClicked = false;

	function updateItemVisibility() {
		if (seeAllClicked) {
			return;
		}
		const initialItemsToShow = 8;

		$items.slice(0, initialItemsToShow).show();
		$items.slice(initialItemsToShow).hide();

		if ($items.length > initialItemsToShow) {
			$seeAllLink.show();
		} else {
			$seeAllLink.hide();
		}
	}  

	$seeAllLink.on('click keypress', function (e: JQuery.Event) {
		if (e.type === 'keypress' && e.which !== 13) {
			return;
		}
		seeAllClicked = true;
		const $firstHiddenItem = $items.filter(':hidden').first();

		$items.show();
		$(this).hide();

		$firstHiddenItem.find('a').focus();
	});

	updateItemVisibility();
	$(window).resize(updateItemVisibility);
}
